import { useFetchClientVulnerabilitiesQuery, useFetchVulnerabilitySectionQuery } from "../../../../services/clientfactfind";
import { useEffect, useMemo } from "react";

const useClientVulnerability = ({ masterAccountId }) => {
    const { refetch, data, isLoading, isFetching, isError, error } = useFetchVulnerabilitySectionQuery({ masterAccountId }, { skip: !masterAccountId });
    const vulnerabilitySectionId = data?.vulnerabilitySectionId;
    const { refetch: fetchClientVulnerabilities,
        data: clientVulnerabilityData,
        isLoading: clientVulnerabilityIsLoading,
        isError: clientVulnerabilityIsError,
        error: clientVulnerabilityError,
        isFetching: clientVulnerabilityIsFetching,
    } = useFetchClientVulnerabilitiesQuery({ vulnerabilitySectionId, masterAccountId }, { skip: !masterAccountId || !vulnerabilitySectionId || vulnerabilitySectionId === undefined });

    useEffect(() => {
        if (vulnerabilitySectionId)
            fetchClientVulnerabilities({ vulnerabilitySectionId, masterAccountId });
    }, [vulnerabilitySectionId, fetchClientVulnerabilities])

    const isDataLoading = useMemo(() => {
        return isLoading || clientVulnerabilityIsLoading || isFetching || clientVulnerabilityIsFetching;
    }, [isLoading, clientVulnerabilityIsLoading, isFetching, clientVulnerabilityIsFetching]);

    const retry = () => {
        if (isError) {
            refetch();
        }
        if (clientVulnerabilityIsError) {
            fetchClientVulnerabilities({ vulnerabilitySectionId, masterAccountId });
        }
    }

    const isDataError = useMemo(() => {
        return isError || clientVulnerabilityIsError;
    }, [isError, clientVulnerabilityIsError])

    const dataError = useMemo(() => isDataError ? {
        sectionDataError: {
            error: error,
            message: "Error fetching the vulnerability section data"
        },
        clientVulnerabilityError: {
            error: clientVulnerabilityError,
            message: "Error fetching the client vulnerabilities data"
        },
    } : null, [error, clientVulnerabilityError, isDataError]);

    return {
        data,
        isLoading,
        clientVulnerabilityIsLoading,
        isDataError,
        dataError,
        clientVulnerabilityData: clientVulnerabilityData || [],
        isFetching,
        clientVulnerabilityIsFetching,
        isDataLoading,
        retry
    }
}

export default useClientVulnerability;